function shadowSettingsService ($http, listingService, localStorageService) {
    const CARS_USER_DATA = 'Cars.userData';

    function phoneReporting() {
        return listingService.getListing().then((result)=> {
            let vehicle = result.listingDetailDto;
            const userData = JSON.parse(localStorageService.getItem(CARS_USER_DATA)) || {};

            let shadowSettingsInfo = {
                phone: vehicle.phoneNumber,
                sellerId: vehicle.customerId,
                vehicleId: vehicle.listingId,
                stockType: vehicle.newCarStockType ? 'New' : 'Used',
                year: vehicle.modelYear,
                make: vehicle.makeName,
                model: vehicle.modelName,
                trim: vehicle.trimName,
                zip: userData.zip,
                "source": "VDP"
            };

            let payload = {
                attributes: shadowSettingsInfo,
                eventType: "PHONE_CLICK"
            };

            let url = `${vehicle.apigeeHost}${vehicle.shadowSettingsProxy}events/PHONE_CLICK/?apikey=${vehicle.apiKey}`;
            let config = {headers: {
                "x-cars-device-id": `${vehicle.visitor.deviceId}`,
                "x-cars-consumer-id": `${vehicle.visitor.consumerId}`,
                "Content-Type": "application/json"
            }};
            return $http.post(url, payload, config);
        });
    }

    return {phoneReporting};
}

shadowSettingsService.$inject = [
    '$http', 'listingService', 'localStorageService'
];

export default shadowSettingsService;
